// extracted by mini-css-extract-plugin
module.exports =  {"predicate":"OSI4m4v8kcGKZZcFTBp7"};